import React, { useEffect } from 'react';
import { Button, makeStyles, InputBase } from '@material-ui/core';
import KenCard from '../../global_components/KenCard';
import PropTypes from 'prop-types';
import CreateEvent from './Components/CreateEvent';

import ConformationModal from './Components/ConformationModal';
import KenSnackbar from '../../Components/KenSnackbar/index';
import KenButton from '../../global_components/KenButton/index';
import KenLoader from '../../Components/KenLoader/index';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { useTranslation } from 'react-i18next';

import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import { FiEdit, FiTrash2 } from 'react-icons/fi';
import {
  createEvents,
  getEvents,
  updateEvent,
  deleteEvent,
  imageUpload,
} from '../../Utils/apiServices';

import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Chip from '@material-ui/core/Chip';
import SearchIcon from '@material-ui/icons/Search';
import KenTabPanel from './Components/KenTabPanel';
import './event.css';

const columns = [
  { id: 'name', label: 'Name', minWidth: 200 },
  { id: 'description', label: 'Description', minWidth: 200 },
  { id: 'startDate', label: 'Start Date', minWidth: 300 },
  { id: 'endDate', label: 'End Date', minWidth: 300 },
  { id: 'action', label: 'Actions', minWidth: 150 },
];

const useStyles = makeStyles({
  root: {
    width: '100%',
  },

  addButton: {
    float: 'right',
    width: 150,
    marginBottom: 16,
  },
  tableHead: {
    backgroundColor: '#22218d',
    color: 'white',
    fontWeight: 700,
    width: 200,
  },
  muiBox: {
    paddingRight: '3rem',
  },
  tableCell: {
    padding: '10px',
    lineHeight: 2,
  },
  showMoreClass: {
    textDecoration: 'underline',
    cursor: 'pointer',
    fontWeight: 700,
  },
  paper: {
    padding: 2,
    textAlign: 'center',
  },
});
function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}
KenTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};
export default function Event() {
  const { t } = useTranslation();
  const [value, setValue] = React.useState(0);
  const [selectedTab, setSelectedTab] = React.useState(0);
  const classes = useStyles();

  const [open, setOpen] = React.useState(false);
  const [eventData, setEventData] = React.useState(null);

  const [isShowTable, setIsShowTable] = React.useState(true);

  const [loading, setLoading] = React.useState(false);

  const [openConfirmModal, setOpenConfirmModal] = React.useState(false);
  const [eventRow, setEventRow] = React.useState(null);
  const [message, setMessage] = React.useState('');

  const [showTab, setShowTab] = React.useState(true);

  //   SnackBar
  const [openSnackbar, setOpenSnackbar] = React.useState(false);
  const [snackbarSeverity, setSnackbarSeverity] = React.useState('success');
  const [snackbarMessage, setSnackbarMessage] = React.useState('');

  // event list
  const [events, setEvents] = React.useState([]);
  const [allEvents, setAllEvents] = React.useState([]);
  const [upcomingEvents, setUpcomingEvents] = React.useState([]);
  const [inProgressEvents, setInprogressEvents] = React.useState([]);
  const [completedEvents, setCompletedEvents] = React.useState([]);

  const [confirmOpen, setConfirmationOpen] = React.useState(false);
  const [title, setTitle] = React.useState('');

  let upcomingEventLength = 0;

  const handleClickOpen = () => {
    setEventData(null);
    setOpen(true);
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') return;
    setOpenSnackbar(false);
  };

  const handleSnackbarOpen = (severity, message) => {
    setOpenSnackbar(true);
    setSnackbarSeverity(severity);
    setSnackbarMessage(message);
  };

  const fileUpload = async (formData) => {
    try {
      setLoading(true);
      const fileResponse = await imageUpload(formData);
      setLoading(false);
      getAllEvents();
    } catch (error) {
      setLoading(false);
    }
  };

  const updateEventDetails = async (payload, fileDetails) => {
    try {
      setLoading(true);
      const eventDetails = await updateEvent(payload);
      if (eventDetails.updateResponse.result.success) {
        if (fileDetails != null) {
          const formData = new FormData();
          formData.append('filename', fileDetails);
          formData.append('recordId', payload.ID);
          fileUpload(formData);
        }
        setLoading(false);
        handleSnackbarOpen('success', t('messages:event_updated_successfully'));
        getAllEvents();
      } else {
        setLoading(false);
        const errorMessage =
          eventDetails.updateResponse !== undefined
            ? eventDetails.updateResponse.result.errors.message
            : eventDetails.message;
        handleSnackbarOpen('error', errorMessage);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const createEvent = async (payload, fileDetails) => {
    try {
      setLoading(true);
      const eventDetails = await createEvents(payload);
      if (eventDetails.createResponse.result.success) {
        if (fileDetails != null) {
          const formData = new FormData();
          formData.append('filename', fileDetails);
          formData.append('recordId', eventDetails.createResponse.result.id);
          fileUpload(formData);
        }
        setLoading(false);
        handleSnackbarOpen('success', t('messages:event_create_successfully'));
        getAllEvents();
      } else {
        setLoading(false);
        const errorMessage =
          eventDetails.createResponse !== undefined
            ? eventDetails.createResponse.result.errors.message
            : eventDetails.message;
        handleSnackbarOpen('error', errorMessage);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const openEditModal = async (e) => {
    setEventData(e);
    setOpen(true);
  };

  const getAllEvents = async (type) => {
    setLoading(true);
    try {
      const events = await getEvents();

      const eventLists = events.data;

      if (eventLists != null) {
        let futureEvents = [];
        let pastEvents = [];
        let inProgressEvents = [];
        let currentDate = new Date();
        currentDate.setHours(0, 0, 0, 0);
        eventLists.forEach((element) => {
          let startDate = new Date(element.StartDateTime);
          let endDate = new Date(element.EndDateTime);

          startDate.setHours(0, 0, 0, 0);
          if (startDate.getTime() >= currentDate.getTime()) {
            futureEvents.push({
              ...element,
              upcoming: true,
            });
          } else {
            pastEvents.push({ ...element, completed: true });
          }
          if (
            startDate.getTime() < currentDate.getTime() &&
            endDate.getTime() >= currentDate.getTime()
          ) {
            inProgressEvents.push({ ...element, inprogress: true });
          }
        });
        let futureSortEvents = futureEvents.sort(
          (a, b) => Date.parse(a.StartDateTime) - Date.parse(b.StartDateTime)
        );
        let inProgressSortEvents = inProgressEvents.sort(
          (a, b) => Date.parse(a.StartDateTime) - Date.parse(b.StartDateTime)
        );
        let pastSortEvents = pastEvents.sort(
          (a, b) => Date.parse(a.StartDateTime) - Date.parse(b.StartDateTime)
        );
        let allEvents = [
          ...futureEvents,
          ...pastEvents,
          ...inProgressSortEvents,
        ];
        let sortedEvent = allEvents.sort(
          (a, b) => Date.parse(a.StartDateTime) - Date.parse(b.StartDateTime)
        );
        upcomingEventLength = futureSortEvents.length;
        setUpcomingEvents(futureSortEvents);
        setInprogressEvents(inProgressSortEvents);
        setCompletedEvents(pastSortEvents);
        setAllEvents(sortedEvent);
        setEvents(futureSortEvents);
        setLoading(false);
        switch (value) {
          case 0:
            setEvents(futureSortEvents);
            break;
          case 1:
            setEvents(allEvents);
            break;
          case 2:
            setEvents(inProgressSortEvents);
            break;
          case 3:
            setEvents(pastSortEvents);
          default:
            break;
        }
      }
    } catch (error) {
      console.log('error ::: ', error);
      setLoading(false);
    }
  };
  const clickConfirmation = async (status) => {
    if (status) {
      setConfirmationOpen(false);
      try {
        setLoading(true);
        setEvents([]);
        const eventDetails = await deleteEvent(eventRow.Id);
        if (eventDetails.deleteResponse.result.success) {
          setLoading(false);
          handleSnackbarOpen(
            'success',
            t('messages:event_deleted_successfully')
          );
          getAllEvents(1);
        } else {
          setLoading(false);
          const errorMessage =
            eventDetails.deleteResponse !== undefined
              ? eventDetails.deleteResponse.result.errors.message
              : eventDetails.message;
          handleSnackbarOpen('error', errorMessage);
        }
      } catch (error) {
        setLoading(false);
      }
    }
  };

  const handleEventBaseOnType = async (newValue) => {
    const type = newValue != null ? newValue : value;
    console.log(' newValue ::::', newValue, value);
    switch (type) {
      case 0:
        setValue(type);
        setEvents(upcomingEvents);
        break;
      case 1:
        setValue(type);
        setEvents(allEvents);
        break;
      case 2:
        setValue(type);
        setEvents(inProgressEvents);
        break;
      case 3:
        setValue(type);
        setEvents(completedEvents);
        break;
      default:
        break;
    }
    await setShowTab(true);
  };

  const searchEventsHandler = async (event) => {
    await setShowTab(false);

    let searchString = event.target.value;

    let events = allEvents;
    let searchResult = events.filter((ev) => {
      return (
        ev.Subject.toLowerCase().includes(searchString.toLowerCase()) ||
        ev.Description.toLowerCase().includes(searchString.toLowerCase())
      );
    });
    switch (value) {
      case 0:
        setEvents(searchResult);
        break;
      case 1:
        setEvents(searchResult);
        break;
      case 2:
        setEvents(searchResult);
        break;
      case 3:
        setEvents(searchResult);
        break;
      default:
        break;
    }
    await setShowTab(true);
  };

  const deleteEventConfirm = (eventValue) => {
    const message = t('messages:delete_confirmation_msg');
    setMessage(message);
    setTitle(eventValue.Subject);
    setEventRow(eventValue);
    setConfirmationOpen(true);
  };

  const handleChange = async (event, newValue) => {
    await setShowTab(false);
    console.log('newValue :::: ', newValue);
    setSelectedTab(newValue);
    handleEventBaseOnType(newValue);
  };

  useEffect(() => {
    setValue(0);
    getAllEvents(0);
    // handleEventBaseOnType(null)
  }, []);

  return (
    <div>
      <AppBar position="static" className="apptopbar">
        <Toolbar>
          <Typography variant="h5">
            {t('labels:Events')}{' '}
            <Chip color="primary" label={allEvents.length} />
          </Typography>
          <div className="search">
            <div className="searchIcon">
              <SearchIcon />
            </div>
            <InputBase
              className="searchInput"
              onChange={searchEventsHandler}
              placeholder={t('messages:Search_by_event_title')}
            />
          </div>
          {/* <div className="filterbox">
            <KenSelect label="Select" placeholder="Select week" required />
          </div> */}
        </Toolbar>
      </AppBar>
      <AppBar className="EventTabBar" position="static">
        <Toolbar>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="simple tabs example"
          >
            <Tab
              label={t('labels:Upcoming') + '(' + upcomingEvents.length + ')'}
              {...a11yProps(0)}
            />
            <Tab
              label={t('labels:All') + '(' + allEvents.length + ')'}
              {...a11yProps(1)}
            />
            <Tab
              label={
                t('labels:In_Progress') + '(' + inProgressEvents.length + ')'
              }
              {...a11yProps(2)}
            />
            <Tab
              label={t('labels:Completed') + '(' + completedEvents.length + ')'}
              {...a11yProps(3)}
            />
          </Tabs>
          <KenButton
            variant="contained"
            color="primary"
            onClick={handleClickOpen}
          >
            <AddCircleOutlineIcon /> {t('labels:Add_Event')}
          </KenButton>
        </Toolbar>
      </AppBar>
      <div className="cardlsitbox">
        <KenCard elevation={0}>
          {showTab && (
            <KenTabPanel
              initialPage={0}
              value={value}
              events={events}
              index={value}
              openEditModal={openEditModal}
              deleteEventConfirm={deleteEventConfirm}
            />
          )}
        </KenCard>
      </div>

      {confirmOpen && (
        <ConformationModal
          confirmOpen={confirmOpen}
          setConfirmationOpen={setConfirmationOpen}
          clickConfirmation={clickConfirmation}
          title={title}
        ></ConformationModal>
      )}

      {open && (
        <CreateEvent
          open={open}
          setOpen={setOpen}
          createEvent={createEvent}
          eventData={eventData}
          updateEventDetails={updateEventDetails}
        ></CreateEvent>
      )}

      {loading && <KenLoader />}
      <KenSnackbar
        message={snackbarMessage}
        severity={snackbarSeverity}
        autoHideDuration={4000}
        open={openSnackbar}
        handleSnackbarClose={handleSnackbarClose}
        position="Bottom-Right"
      />
    </div>
  );
}
